const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SERVICE_LEVEL_DASHBOARD_ENDPOINT =
  '/outbound/dashboards/service-level/url';
const GET_SERVICE_LEVEL_DASHBOARD = BASE_URL + SERVICE_LEVEL_DASHBOARD_ENDPOINT;

export { GET_SERVICE_LEVEL_DASHBOARD };
